import { CardView } from "./CardView";
import { DropDownFrame } from "./Frame";
import PatientHeader from "./PatientHeader";
import { TableView } from "./TableView";
import injection from "../../../../assets/patientcharts/bx_task.svg";
import visitIcon from "../../../../assets/patientcharts/visitIcon.svg";
import labsIcon from "../../../../assets/patientcharts/labsIcon.svg";
import Records from "../../../../assets/patientcharts/Records.svg";
import Referrals from "../../../../assets/patientcharts/Referrals.svg";
import notesIcon from "../../../../assets/patientcharts/notesIcon.svg";
import Refill from "../../../../assets/patientcharts/Refill.svg";
import Schedule from "../../../../assets/patientcharts/Schedule.svg";
import LabsIcon from "../../../../assets/patientcharts/akar-icons_dashboard.png";

import ProcedureIcon from "../../../../assets/patientcharts/pulseicon.svg";
import { useEffect, useState } from "react";

import dayjs from "dayjs";
import { Backdrop, CircularProgress } from "@mui/material";
import api from "../../../../api/api";
import { useNavigate } from "react-router-dom";
import { use } from "react";
import { set } from "date-fns";
import { se } from "date-fns/locale";
import { eventBus } from "../../../../utils/eventBus";
import { useDispatch } from "react-redux";
import {
  updatelov2Value,
  updatelovValue,
  updateTov2Value,
  updateTovValue,
} from "../../../../reduxtoolkit/dump";
import { setOrders } from "../../../../reduxtoolkit/orders/ordersSlice";
import ToastMessage from "../../../../utils/mui/righttoptoast";

const formatDate = (dateString) => {
  return dayjs(dateString).format("YYYY-MM-DD");
};

const groupOrdersByType = (orders) => {
  return orders.reduce((acc, order) => {
    const orderType = order.ordertype;
    if (!acc[orderType]) {
      acc[orderType] = []; // Initialize the array if it doesn't exist
    }
    acc[orderType].push(order); // Add the order to the corresponding type
    return acc;
  }, {});
};

const SummaryTabWrap = ({ dataId, searchdate,setFetchedData,isloaderactive, fetchedData, }) => {
  const [view, setView] = useState(1);
  const [loading, setLoading] = useState(false);
  const [summaryData, setSummaryData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchDate, setSearchDate] = useState(formatDate(searchdate));
  const practiseid = window.getPracticeId();
  const [previousvitals, setPreviousVitals] = useState([]);
  const [dxvitals, setDxvitals] = useState([]);
  const [isLoadingVitals, setIsLoadingVitals] = useState(false);
   const [openToast, setOpenToast] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [toastSeverity, setToastSeverity] = useState("success");
  const dispatch = useDispatch();
const isToday = dayjs(searchDate).isSame(dayjs(), "day");


  const fetchSummaryData = async (x) => {
    if(!x){
      setIsLoading(true);
    }
    
    try {
      const payload = {
        patientid: dataId.patientid,
        orderdate: searchDate,
      };

      const response = await api.post(`/v1/${practiseid}/orders/get`, payload);
      const selectedsuggestions = await api.post(
        `/v1/${practiseid}/orders/patient/${dataId.patientid}/get-orders`,
        {
          appointmentid: dataId.appointmentid,
          // "orderdate": data.created_at ? new Date(data.created_at).toISOString().split('T')[0] : "Invalid date"
          orderdate:
            dataId.startdate &&
            dataId.startdate.includes(" ") &&
            !isNaN(Date.parse(dataId.startdate.split(" ")[0]))
              ? dataId.startdate.split(" ")[0]
              : new Date().toISOString().split("T")[0],
        }
      );
      if (selectedsuggestions.status === 200) {
        const lovtovItem = selectedsuggestions?.data?.lovtov?.[0];
        console.log("set in redux", selectedsuggestions?.data);
dispatch(setOrders(selectedsuggestions?.data))
        if (lovtovItem) {
     
          dispatch(updatelovValue(lovtovItem.lov));
          dispatch(updateTovValue(lovtovItem.tov));
          dispatch(updatelov2Value(lovtovItem.lov2));
          dispatch(updateTov2Value(lovtovItem.tov2));
        } else {
          // Optional: set defaults if needed
          dispatch(updatelovValue(null));
          dispatch(updateTovValue(null));
          dispatch(updatelov2Value(null));
          dispatch(updateTov2Value(null));
        }
      }
      if (response.status === 200) {
     // API full order objects
const apiOrders = response.data; 


isloaderactive.current = false;

// Replace orders for the correct patient
const updated = fetchedData.map((patient, idx) => {
;

  if (patient.patientid === dataId.patientid) {


    const updatedPatient = {
      ...patient,
      orders: apiOrders, // <-- DIRECT REPLACE
    };


    return updatedPatient;
  }


  return patient;
});


  if (dayjs(searchDate).isSame(dayjs(), "day")) {
    setFetchedData(updated);
  }



        // console.log("Fetched data:", response.data);
        setSummaryData(response.data); // Access the `data` array from the response
      }else{
        const apiOrders = []; 


isloaderactive.current = false;

// Replace orders for the correct patient
const updated = fetchedData.map((patient, idx) => {


  if (patient.patientid === dataId.patientid) {


    const updatedPatient = {
      ...patient,
      orders: apiOrders, // <-- DIRECT REPLACE
    };

 
    return updatedPatient;
  }

;
  return patient;
});

setFetchedData(updated);
        setSummaryData([])
      }
      isloaderactive.current=true
    } catch (error) {
      console.error(
        "Error fetching data:",
        error.response ? error.response.data : error
      );
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const handleFetchSummary = (payload) => {
      fetchSummaryData(payload);
    };

    eventBus.on("fetchSummary", handleFetchSummary);

    return () => {
      eventBus.off("fetchSummary", handleFetchSummary);
    };
  }, []);

  const fetchpreviousvitals = async () => {
    try {
      setIsLoadingVitals(true);
      const response = await api.post(
        `/v1/${practiseid}/vitals/patient/${dataId.patientid}/vitalscurrent`
      );

      if (response.status === 200) {
        setPreviousVitals(response?.data || []);
      } else {
        setPreviousVitals([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingVitals(false);
    }
  };
  const fetchpreviousdx = async () => {
    try {
      setIsLoadingVitals(true);
      const response = await api.post(
        `/v1/${practiseid}/patient/${dataId.patientid}/chart/visit-summary`,
        {
          provider: dataId?.providerid,
          purpose: dataId?.purpose,
          st_date: dayjs(dataId?.startdate).format("YYYY-MM-DD"),
        }
      );

      if (response.status === 200) {
        setDxvitals(response?.data || []);
      } else {
        setDxvitals([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingVitals(false);
    }
  };
  useEffect(() => {
    fetchSummaryData();
  }, [view, searchDate]);
const handleDeleteOrder=async(orderid)=>{
  try {
    setLoading(true)
      const response = await api.delete(`/v1/${practiseid}/orders/delete/multiple`, {
        data: {
          ordersArray: [orderid],
          orderdate:dayjs(dataId?.startdate).format("YYYY-MM-DD")
        },
      });
      if(response.status===200){
setToastMessage("Order deleted successfully");
setToastSeverity("success");
setOpenToast(true);
fetchSummaryData(true);
      }else{
setToastMessage(response?.message||"Failed to delete order");
setToastSeverity("error");
setOpenToast(true);
      }
  } catch (error) {
    console.log(error)
  }finally{
setLoading(false)
  }

}
  const handleToggle = (value) => {
    setView(value);
  };
  // useEffect(()=>{
  //    if(dataId.patientid) {
  //        fetchpreviousvitals()
  //    }

  // },[dataId])
 
  // Group summary data by order type
  const groupedSummaryData = groupOrdersByType(summaryData);
  const navigate = useNavigate();
  return (
    <>
            <div className="px-2 pb-2 pt-3 overflow-y-auto max-h-[calc(100vh-150px)]"
          style={{ scrollbarWidth: "none" }}
      >
        <DropDownFrame
          data={dataId}
          isLoadingVitals={isLoadingVitals}
          dxvitals={dxvitals}
          fetchpreviousdx={fetchpreviousdx}
          fetchpreviousvitals={fetchpreviousvitals}
          previousVitals={previousvitals}
        />
        <PatientHeader
          viewStatus={view}
          searchDate={searchDate}
          handleView={handleToggle}
          setSearchDate={setSearchDate}
        />
        <div
          className="overflow-y-auto h-[450px] pt-2 pb-3.5"
          style={{ scrollbarWidth: "none" }}
        >
          {isLoading ? (
            <div className="flex justify-center min-h-[200px] items-end w-[100%] ">
              <div>
                <CircularProgress />
              </div>
            </div> // Loading indicator
          ) : summaryData?.length === 0 ? (
            <div className="flex justify-center min-h-[200px] items-end w-[100%]">
              <div className="text-[#6A7282] font-inter font-normal text-[18px]">
                No order at this time
              </div>
            </div>
          ):
           view ? (
            <div className="grid">
              <TableView summaryData={summaryData} handleDeleteOrder={handleDeleteOrder} />
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-2">
              {Object.entries(groupedSummaryData).length > 0 ? (
                Object.entries(groupedSummaryData).map(
                  ([ordertype, orders]) => {
                    console.log("ordertype", orders);
                    return (
                      <CardView
                        key={ordertype} // Unique key for each order type
                        icon={
                          ordertype?.toLowerCase() == "labs"
                            ? labsIcon
                            : ordertype?.toLowerCase() == "visit"
                            ? visitIcon
                            : ordertype?.toLowerCase() == "visits"
                            ? visitIcon
                            : ordertype?.toLowerCase() == "injections"
                            ? injection
                            : ordertype?.toLowerCase() == "refills"
                            ? Refill
                            : ordertype?.toLowerCase() == "mrecord"
                            ? injection
                            : ordertype?.toLowerCase() == "schedule-rto"
                            ? Schedule
                            : ordertype?.toLowerCase() == "referrals"
                            ? Referrals
                            : ordertype?.toLowerCase() == "notes"
                            ? notesIcon
                            : ProcedureIcon
                        }
                        title={ordertype} // Use ordertype as the title
                        summaryData={orders} // Pass the grouped orders as summary data
                      />
                    );
                  }
                )
              ) : (
                <div className="h-[200px]  w-[100%] flex text-center justify-center items-center">
                  <p className=" pr-4 text-[#8A8D90]">No orders found.</p>
                </div>
              )}
            </div>
          )}
        </div>
          <ToastMessage
        message={toastMessage}
        severity={toastSeverity}
        open={openToast}
        handleClose={() => setOpenToast(false)}
      />
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
            backgroundColor: "rgba(0, 0, 0, 0.7)", // reduced opacity (default is 0.5)
          }}
          open={isLoadingVitals}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </>
  );
};

export default SummaryTabWrap;
